import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { UserSearchComponent } from './user-search/user-search.component';
import { UserAddUserModalModule } from '../user-add-modal/user-add-user-modal.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    UserAddUserModalModule,
    TooltipModule.forRoot(),
  ],
  declarations: [UserSearchComponent]
})
export class UserSearchModule { }
